import { Injectable } from '@angular/core';
import { LocalStorageKeys } from '../core/constants';
import { DeviceActivityColors } from '../core/constants/device-activity-colors';
import * as i0 from "@angular/core";
import * as i1 from "./menu-update.service";
export class LocalStorageService {
    constructor(menuUpdateService) {
        this.menuUpdateService = menuUpdateService;
    }
    ngOnInit() { }
    handleFavoriteDevices(MID, selection, templateId) {
        let devices = [];
        let url = this.getBaseUrl();
        let userName = JSON.parse(localStorage.getItem(LocalStorageKeys.LOGIN_USER));
        let localStorageKey = url + '-' + userName + 'favorite';
        let favoriteDevices = JSON.parse(localStorage.getItem(localStorageKey));
        if (favoriteDevices == null) {
            let device = {};
            device['MID'] = MID;
            device['TemplateId'] = templateId;
            devices.push(device);
            localStorage.setItem(localStorageKey, JSON.stringify(devices));
        }
        else {
            if (favoriteDevices.length > 0) {
                favoriteDevices.forEach((device) => {
                    devices.push(device);
                });
                let index = devices.findIndex((device) => device['MID'] == MID);
                if (selection) {
                    if (index == -1) {
                        let device = {};
                        device['MID'] = MID;
                        device['TemplateId'] = templateId;
                        devices.push(device);
                        localStorage.setItem(localStorageKey, JSON.stringify(devices));
                    }
                }
                else {
                    if (index != -1) {
                        devices.splice(index, 1);
                        localStorage.setItem(localStorageKey, JSON.stringify(devices));
                    }
                }
            }
            else {
                let device = {};
                device['MID'] = MID;
                device['TemplateId'] = templateId;
                devices.push(device);
                localStorage.setItem(localStorageKey, JSON.stringify(devices));
            }
        }
    }
    getBaseUrl() {
        // Needed on Angular 8+
        const parsedUrl = new URL(window.location.href);
        const baseUrl = parsedUrl.origin;
        //console.log(baseUrl);
        return baseUrl;
    }
    menuNeedsToBeUpdated() {
        this.menuUpdateService.getMenuUpdatedValue(true);
    }
    updateRecentDevices(viewedDevice, templateId) {
        let devices = [];
        let url = this.getBaseUrl();
        let userName = JSON.parse(localStorage.getItem(LocalStorageKeys.LOGIN_USER));
        let localStorageKey = url + '-' + userName + 'recent';
        let localDevices = JSON.parse(localStorage.getItem(localStorageKey));
        if (localDevices == null) {
            let device = {};
            device['MID'] = viewedDevice;
            device['TemplateId'] = templateId;
            device['Order'] = 1;
            devices.push(device);
            localStorage.setItem(localStorageKey, JSON.stringify(devices));
        }
        else {
            if (localDevices.length > 0) {
                localDevices.forEach((device) => {
                    devices.push(device);
                });
                devices.sort(function (a, b) {
                    return b.Order - a.Order;
                });
                if (devices.length != 50) {
                    let MIDExist = devices.findIndex((device) => device['MID'] == viewedDevice);
                    if (MIDExist == -1) {
                        let latestRecentDevice = devices[0];
                        let device = {};
                        device['MID'] = viewedDevice;
                        device['TemplateId'] = templateId;
                        device['Order'] = latestRecentDevice['Order'] + 1;
                        devices.push(device);
                        localStorage.setItem(localStorageKey, JSON.stringify(devices));
                    }
                    else {
                        let latestRecentDevice = devices[0];
                        let updatedDevice = {};
                        updatedDevice['MID'] = viewedDevice;
                        updatedDevice['TemplateId'] = templateId;
                        updatedDevice['Order'] = latestRecentDevice['Order'] + 1;
                        devices.splice(MIDExist, 1);
                        devices.push(updatedDevice);
                        localStorage.setItem(localStorageKey, JSON.stringify(devices));
                    }
                }
                else {
                    devices.pop();
                    let MIDExist = devices.findIndex((device) => device['MID'] == viewedDevice);
                    if (MIDExist == -1) {
                        let latestRecentDevice = devices[0];
                        let device = {};
                        device['MID'] = viewedDevice;
                        device['TemplateId'] = templateId;
                        device['Order'] = latestRecentDevice['Order'] + 1;
                        devices.push(device);
                        localStorage.setItem(localStorageKey, JSON.stringify(devices));
                    }
                }
            }
        }
        this.menuNeedsToBeUpdated();
    }
    updateDevice(data) {
        let devices = [];
        let currentDevice = { Device: data };
        let localDevices = JSON.parse(this.getAllDeviceDetails());
        if (localDevices != null) {
            localDevices.forEach((device) => {
                devices.push(device);
            });
        }
        devices.push(currentDevice);
        sessionStorage.setItem(LocalStorageKeys.DEVICE_DETAILS, JSON.stringify(devices));
    }
    getDevice(mid) {
        let device = null;
        let localDevices = JSON.parse(this.getAllDeviceDetails());
        if (localDevices != null) {
            for (let item of localDevices) {
                if (item.Device.MID === mid) {
                    device = item.Device;
                    break;
                }
            }
        }
        return device;
    }
    removeAllDevices() {
        sessionStorage.removeItem(LocalStorageKeys.DEVICE_DETAILS);
    }
    removeSessionStorageDeviceByMid(mid) {
        let devices = [];
        let allDevices = JSON.parse(this.getAllDeviceDetails());
        if (allDevices != null) {
            for (let item of allDevices) {
                if (item.Device.MID !== mid) {
                    devices.push(item);
                }
            }
        }
        sessionStorage.setItem(LocalStorageKeys.DEVICE_DETAILS, JSON.stringify(devices));
    }
    removeLocalStorageDeviceByMid(mid) {
        let devices = [];
        let cachedDevices = this.getAllDevices();
        if (cachedDevices != null) {
            for (let item of cachedDevices) {
                if (item.MID !== mid) {
                    devices.push(item);
                }
            }
        }
        this.updateDeviceListLocalStorage(devices);
    }
    createDeviceLocalStorage(devices) {
        this.updateDeviceListLocalStorage(devices);
    }
    // minified the property names to the single character
    getMinifiedDeviceList(devices) {
        let deviceList = [];
        devices.forEach((element) => {
            let item = {
                M: element.MID,
                N: element.Name,
                T: element.TemplateId,
                D: element.Description,
                P: element.LatestPulse,
            };
            deviceList.push(item);
        });
        return deviceList;
    }
    getDetailDeviceList(devices) {
        let deviceList = [];
        devices.forEach((element) => {
            var item = {
                MID: element.M,
                Name: element.N,
                TemplateId: element.T,
                Description: element.D,
                LatestPulse: element.P,
            };
            deviceList.push(item);
        });
        return deviceList;
    }
    updateDeviceListLocalStorage(deviceList) {
        try {
            let minified = this.getMinifiedDeviceList(deviceList);
            let compressed = this.compressData(minified);
            localStorage.setItem(LocalStorageKeys.CACHED_DEVICES, JSON.stringify(compressed));
            console.log('Local storage was updated');
        }
        catch (err) {
            //store to the varibale and set local storage to null
            localStorage.removeItem(LocalStorageKeys.CACHED_DEVICES);
            this.devices = this.arrangeDeviceList(deviceList);
            console.log('Local storage was exceeded');
        }
    }
    //get all devices from local storage or variable
    getAllDevices() {
        let devices = null;
        let cachedDevices = this.decompressData(localStorage.getItem(LocalStorageKeys.CACHED_DEVICES));
        if (cachedDevices != null) {
            devices = this.arrangeDeviceList(this.getDetailDeviceList(cachedDevices));
        }
        else {
            if (this.devices != null) {
                devices = this.devices;
            }
        }
        return devices;
    }
    clearDeviceListCache() {
        localStorage.removeItem(LocalStorageKeys.CACHED_DEVICES);
        this.devices = null;
    }
    setQuantities(quantities) {
        localStorage.setItem(LocalStorageKeys.QUANTITIES, JSON.stringify(quantities));
    }
    getQuantities() {
        return JSON.parse(localStorage.getItem(LocalStorageKeys.QUANTITIES));
    }
    // set the pulze updated time based on LatestPulse
    arrangeDeviceList(devices) {
        devices.forEach((device, deviceIndex) => {
            if (device.LatestPulse != null) {
                // return device['lastDeviceStatus'] = this.getDeviceStatus(device.LatestPulse);
                let pulseColor = this.getDeviceStatus(device.LatestPulse);
                device['lastDeviceStatus'] = pulseColor;
                if (pulseColor == DeviceActivityColors.GREEN) {
                    device['lastDevicePulseTime'] =
                        'Last Device Pulse: less than 2 hours ago';
                }
                else if (pulseColor == DeviceActivityColors.AMBER) {
                    device['lastDevicePulseTime'] =
                        'Last Device Pulse: between 2 and 24 hours ago';
                }
                else if (pulseColor == DeviceActivityColors.RED) {
                    device['lastDevicePulseTime'] =
                        'Last Device Pulse: more than 1 day ago';
                }
                else {
                    device['lastDevicePulseTime'] = 'Last Device Pulse: never';
                }
                return device;
            }
            else {
                // return device['lastDeviceStatus'] = this.getDeviceStatus();
                device['lastDeviceStatus'] = this.getDeviceStatus();
                device['lastDevicePulseTime'] = 'Last Device Pulse: never';
                return device;
            }
        });
        return devices;
    }
    // get the device status based on the pulse time
    getDeviceStatus(pulseTime = null) {
        let color = DeviceActivityColors.GRAY;
        if (pulseTime != null) {
            var timeDiffMilliseconds = new Date().getTime() - new Date(pulseTime).getTime();
            var diffHours = Math.round(timeDiffMilliseconds / (1000 * 3600));
            var diffDays = Math.round(diffHours / 24);
            if (diffDays > 1) {
                color = DeviceActivityColors.RED;
            }
            else if (diffHours <= 2) {
                color = DeviceActivityColors.GREEN;
            }
            else if (diffHours > 2 && diffDays <= 1) {
                color = DeviceActivityColors.AMBER;
            }
            else {
                console.log(pulseTime);
            }
        }
        return color;
    }
    getAllDeviceDetails() {
        return sessionStorage.getItem(LocalStorageKeys.DEVICE_DETAILS);
    }
    // compress and decompress data using "compressed-json" angular library
    compressData(object) {
        var cjson = require('compressed-json');
        var compressed = cjson.compress(object);
        return compressed;
    }
    decompressData(text) {
        var cjson = require('compressed-json');
        const restored = cjson.decompress(JSON.parse(text));
        return restored;
    }
    getDeviceObservations(mid) {
        let device = this.getDevice(mid);
        if (device != null) {
            return device['Metadata']['Observations'].sort(function (a, b) {
                return parseFloat(a.Id) - parseFloat(b.Id);
            });
        }
        return [];
    }
    getDeviceEnumerations(mid) {
        var _a;
        let device = this.getDevice(mid);
        if (device != null && device['Metadata']['EnumerationGroups']) {
            return (_a = device['Metadata']['EnumerationGroups']) === null || _a === void 0 ? void 0 : _a.sort(function (a, b) {
                return parseFloat(a.Id) - parseFloat(b.Id);
            });
        }
        return [];
    }
    setColorTheme(theme) {
        localStorage.setItem(LocalStorageKeys.COLOR_THEME, theme);
    }
    getColorTheme() {
        return localStorage.getItem(LocalStorageKeys.COLOR_THEME);
    }
}
LocalStorageService.ɵfac = function LocalStorageService_Factory(t) { return new (t || LocalStorageService)(i0.ɵɵinject(i1.MenuUpdateService)); };
LocalStorageService.ɵprov = i0.ɵɵdefineInjectable({ token: LocalStorageService, factory: LocalStorageService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(LocalStorageService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], function () { return [{ type: i1.MenuUpdateService }]; }, null); })();
//# sourceMappingURL=local-storage.service.js.map